<section class="main">
  <h2>Add User Config</h2>
  <hr />
  <form [formGroup]="Village_form">
    <mat-form-field>
      <mat-label>Choose Village</mat-label>
      <mat-select multiple formControlName="villages">
        <mat-option *ngFor="let item of village_list" [value]="item.id">
          {{ item.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field>
            <mat-label>Choose Type</mat-label>
            <mat-select  formControlName="user_type">
              <mat-option *ngFor="let item of types_arr" [value]="item.id">
                {{ item.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

    <div>
      <mat-slide-toggle formControlName="anti_passback" [color]="color">
        Anti passback
      </mat-slide-toggle>
    </div>

    <div class="mt-3">
      <mat-slide-toggle formControlName="vip_access" [color]="color">
        Vip access
      </mat-slide-toggle>
    </div>
    <div class="mt-3">
      <mat-slide-toggle formControlName="applying_quota" [color]="color">
        Applying quota
      </mat-slide-toggle>
    </div>
    <div class="mt-3">
      <mat-slide-toggle formControlName="owner_existence" [color]="color">
        Owner existence
      </mat-slide-toggle>
    </div>
  </form>

  <div class="footer mt-4">
    <button class="btn addGate" (click)="add_user_config()">
      Add User Config
    </button>
    <button class="btn" mat-dialog-close>Cancel</button>
  </div>
</section>
